<div class="card title-card mb-4">
  <div class="flex align-items-center">
    <i class="pi mr-1 title-card-icon" [class.pi-plus-circle]="mode === 'create'" [class.pi-pencil]="mode === 'edit'"></i>
    <p class="mb-0 text-3xl title">
      {{(mode == 'create' ? 'misc.creation.defaultPropertyType' : 'misc.edition.defaultPropertyType') | transloco | capitalize}}
    </p>
  </div>
</div>
<div class="card step-card flex flex-column">
  <form [formGroup]="typeForm" *ngIf="typeForm">
    <div class="grid">

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="name">{{'model.propertyType' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <input pInputText id="name" type="text" formControlName="name" class="w-full">
        </div>
        <app-validation-errors [control]="typeForm.get('name')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="unit">{{'attribute.unit' | transloco}} (*)</label>
        </div>
        <div class="col-12 p-fluid">
          <p-autoComplete formControlName="unit" [showEmptyMessage]="true" [suggestions]="filteredUnits" class="w-full"
                          (completeMethod)="filterUnit($event)" [minLength]="1" id="unit"></p-autoComplete>
        </div>
        <app-validation-errors [control]="typeForm.get('unit')"></app-validation-errors>
      </div>

      <div class="col-12 md:col-12 lg:col-6 xl:col-4">
        <div class="form-field col-12">
          <label for="dataType">{{'attribute.dataType' | transloco}} (*)</label>
        </div>
        <div class="col-12">
          <p-dropdown
            *ngIf="dataTypes"
            [placeholder]="'select.type' | transloco"
            [filter]="false"
            [options]="dataTypes"
            styleClass="w-full"
            formControlName="dataType"
            id="dataType"
          >
            <ng-template let-dataType pTemplate="selectedItem"> {{dataType.label | transloco}} </ng-template>
            <ng-template let-dataType pTemplate="item"> {{dataType.label | transloco}} </ng-template>
          </p-dropdown>
        </div>
        <app-validation-errors [control]="typeForm.get('dataType')"></app-validation-errors>
      </div>

    </div>
  </form>
  <div class="mt-auto">
    <div class="flex justify-content-between mt-4">
      <button
        [label]="'common.cancel' | transloco"
        (click)="cancel()"
        pButton
        class="p-button-danger ml-2"
        iconPos="right"
      ></button>
      <p-button
        *ngIf="typeForm" [disabled]="!typeForm.valid"
        [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
        [loading]="persistingChanges"
        (onClick)="persistTypeData()"
        styleClass="p-button-primary"
        class="mr-2"
      ></p-button>
    </div>
  </div>
</div>
